export default "__VITE_ASSET__C3btxvT0__"